import { useEffect } from "react";

// Main domain (academic.carduldetineret.ro) intentionally shows an empty white page.
export default function BlankPage() {
  useEffect(() => {
    document.title = "";
  }, []);

  return <main className="min-h-screen bg-white" data-testid="blank-page" />;
}
